/* eslint-disable no-empty */
import React, { useContext, useState, useEffect } from "react";
import PropTypes from "prop-types";
import CredentialsViewComponent from "./CredentialsViewComponent_v2";
import CredentialsViewComponentMain from "./CredentialsViewComponent_mainLogin";
import { CredsContext } from "./Contexts";

function CredentialsViewContainer(props) {
  const credsContext = useContext(CredsContext);
  const creds = credsContext.creds;
  const [dirty, isDirty] = useState(false);

  useEffect(() => {
    if (creds.company && creds.username && creds.password) {
      try {
        props.setLoginDisabled(false);
      } catch (e) {}
    } else {
      try {
        props.setLoginDisabled(true);
      } catch (e) {}
    }
  }, []);

  const handleRadioChange = (event) => {
    const radioValue = event.target.value;
    /*let instanceInfoCopy = { ...props.passedInstanceInfo };
    instanceInfoCopy.instanceType = radioValue;
    props.changeHandler(instanceInfoCopy);*/
    creds.instanceType = radioValue;
    credsContext.setCreds(creds);
    isDirty(!dirty);
  };

  const handleInputChange = (event) => {
    const inputId = event.target.id;
    const inputValue = event.target.value;
    //let instanceInfoCopy = { ...props.passedInstanceInfo };

    switch (inputId) {
      case "companyField":
        creds.orig_company =
          inputValue == "Leanswift Solutions Inc" ? "Genericomp" : inputValue;
        break;
      case "usernameField":
        creds.orig_username = inputValue;
        break;
      case "passwordField":
        creds.password = inputValue;
        break;
    }
    if (creds.orig_company && creds.orig_username && creds.password) {
      try {
        props.setLoginDisabled(false);
      } catch (e) {}
    } else {
      try {
        props.setLoginDisabled(true);
      } catch (e) {}
    }
    credsContext.setCreds(creds);
    isDirty(!dirty);

    //props.changeHandler(instanceInfoCopy);
  };

  if (creds) {
    return props.boxSize == "large" ? (
      <CredentialsViewComponentMain
        radioChangeHandler={handleRadioChange}
        inputChangeHandler={handleInputChange}
        handleKeyPress={props.handleKeyPress}
        boxSize={props.boxSize}
      />
    ) : (
      <CredentialsViewComponent
        //passedInstanceInfo={creds}
        radioChangeHandler={handleRadioChange}
        inputChangeHandler={handleInputChange}
        handleKeyPress={props.handleKeyPress}
        boxSize={props.boxSize}
      />
    );
  }
}

export default CredentialsViewContainer;

CredentialsViewContainer.propTypes = {
  changeHandler: PropTypes.func,
  passedInstanceInfo: PropTypes.object,
  creds: PropTypes.object,
  handleKeyPress: PropTypes.func,
  boxSize: PropTypes.string,
  setLoginDisabled: PropTypes.func,
};
